// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana Process Types
 * Auto-generated input/output schemas for every Rana process tag. Do not edit manually.
 *
 * The version of the OpenAPI document: generated
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { RanaFile } from "./RanaFile";
import {
  RanaFileFromJSON,
  RanaFileFromJSONTyped,
  RanaFileToJSON,
  RanaFileToJSONTyped,
} from "./RanaFile";

/**
 *
 * @export
 * @interface ComputeMaxWaterdepthOutput
 */
export interface ComputeMaxWaterdepthOutput {
  /**
   *
   */
  maxWaterDepthRaster: RanaFile;
}

/**
 * Check if a given object implements the ComputeMaxWaterdepthOutput interface.
 */
export function instanceOfComputeMaxWaterdepthOutput(
  value: object
): value is ComputeMaxWaterdepthOutput {
  if (
    (!("maxWaterDepthRaster" in (value as Record<string, any>)) &&
      !("max_water_depth_raster" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["maxWaterDepthRaster"] === undefined &&
      (value as Record<string, any>)["max_water_depth_raster"] === undefined)
  )
    return false;
  return true;
}

export function ComputeMaxWaterdepthOutputFromJSON(json: any): ComputeMaxWaterdepthOutput {
  return ComputeMaxWaterdepthOutputFromJSONTyped(json, false);
}

export function ComputeMaxWaterdepthOutputFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): ComputeMaxWaterdepthOutput {
  if (json == null) {
    return json;
  }
  return {
    maxWaterDepthRaster: RanaFileFromJSON(json["max_water_depth_raster"]),
  };
}

export function ComputeMaxWaterdepthOutputToJSON(json: any): ComputeMaxWaterdepthOutput {
  return ComputeMaxWaterdepthOutputToJSONTyped(json, false);
}

export function ComputeMaxWaterdepthOutputToJSONTyped(
  value?: ComputeMaxWaterdepthOutput | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    max_water_depth_raster: RanaFileToJSON(value["maxWaterDepthRaster"]),
  };
}
